import { render } from "./settingDoctor.vue?vue&type=template&id=92a6fea4&scoped=true"
import script from "./settingDoctor.vue?vue&type=script&lang=js"
export * from "./settingDoctor.vue?vue&type=script&lang=js"

import "./settingDoctor.vue?vue&type=style&index=0&id=92a6fea4&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a6fea4"]])

export default __exports__